import React from 'react';

import { Body } from '@depop/web-thrift-ui/Typography';
import { CancelIcon } from '@depop/web-ui-kit/Icons/CancelIcon';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { getTranslationFromPrefix } from '@/modules/localisation/helper';

type Props = {
  name: string;
  handleClick: () => void;
  isFilterableYMALExperiment?: boolean;
};

export function ActiveFilterButton({
  name,
  handleClick,
  isFilterableYMALExperiment,
}: Props) {
  const t = useTranslations('search');

  return (
    <button
      className={clsx({
        [styles.activeFilter]: true,
        [styles.filterableYMALActiveFilter]: isFilterableYMALExperiment,
      })}
      onClick={handleClick}
      aria-label={`${t('ClearFilterTooltip')}: ${name}`}
    >
      <Body variant="sm-regular" as="span">
        {getTranslationFromPrefix(name, t, 'ActiveFilter')}
      </Body>
      <CancelIcon
        className={styles.activeFilterCloseIcon}
        title={`${t('ClearFilterTooltip')}: ${name}`}
      />
    </button>
  );
}
